import React from "react";
import { navigate } from "../../lib/router";
import { Features } from "./components/FeaturesSection";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import LandingHero from "./components/LandingHero";
import PricingSection from "./components/PricingSection";
import Navbar from "../../components/Navbar";



export function LandingPage() {
    return (
      <div className="min-h-screen w-full flex flex-col bg-white text-neutral-900">
        <Navbar />
        <main className="flex-1 flex flex-col">
          <LandingHero />
        
        <section className="relative w-full bg-neutral-50 py-0 z-0">
          <Features />
        </section>
        <PricingSection onSelectPlan={() => navigate("/login")}/>
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}

export default LandingPage;
